import { EventEmitter, Input, OnInit, Output, Directive } from '@angular/core';

@Directive()
export abstract class AbstractItemList<T> implements OnInit {

  @Input()
  items: T[];

  @Output()
  onItemSelected = new EventEmitter<T>();

  protected constructor() {
  }

  itemSelected(item: T) {
    this.onItemSelected.emit(item);
  }

  abstract loadItems();

  ngOnInit(): void {
    if (!this.items) {
      this.loadItems();
    }
  }

  addItem(item: T) {
    this.items.push(item);
  }

}
